<template>
    <div>
        <app-dialog :is-product-campaing-details="true" :value="isOpen" @input="$emit('input', $event)" :title="$t('campaigns.availableOptions')" :subtitle="product.designation" :width="getDialogWidth" isPersistent>
            <template v-slot:content>
                <v-container v-if="areCampaignsLoading" class="main-container d-flex justify-center align-center p-0">
                    <v-progress-circular indeterminate style="margin: auto"></v-progress-circular>
                </v-container>

                <v-container v-else class="main-container d-flex justify-center align-start p-0">
                    <div class="d-flex flex-column" style="width: 100%">
                        <v-row class="d-flex align-center justify-space-between mx-0 mt-0  search-options" v-if="isSimpleCampaings && showSearchOptions">
                            <v-col cols="12" class="d-flex mx-0 mt-0 pt-0 responsive-cols">
                                <v-col cols="4" class="show-products-text-field">
                                    <v-text-field style="padding-top: 0;"
                                        v-model="searchArticle"
                                        append-icon="mdi-magnify"
                                        :label="$t('campaigns.searchProduct')"
                                        single-line
                                        hide-details
                                        clearable>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="8" class="d-flex mx-0 mt-0 pt-0 show-products-radio">
                                    <v-checkbox class="show-selected-products"
                                            :disabled="isDisabledSelected"
                                            v-model="showSelected"
                                            @change="changeShowSelectedCampaigns"
                                            :label="$t('campaigns.onlyApplied')">
                                    </v-checkbox>
                                </v-col>
                             </v-col>
                         </v-row>
                        <v-expansion-panels mandatory v-if="hasActiveCampaign && product.tax" class="d-flex flex-column" style="margin-bottom: 16px">
                            <v-expansion-panel active-class="myprovet-expansion-panel">
                                <v-expansion-panel-header class="campaign-form-expansion-header" hide-actions>
                                    <v-container class="pb-0">
                                        <v-row>
                                            <v-col cols="12">
                                                <strong class="font-size-md dark-blue-color mt-1">{{ $t('campaigns.noCampaign') }}</strong>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-expansion-panel-header>

                                <v-expansion-panel-content>
                                    <v-card class="mt-4">
                                        <product-shopping-cart  :product="product" :no-campaign="true" :account-blocked-message="accountBlockedMessage" :current-search-term="currentSearchTerm" @open-product-details="openProductDetails($event)"></product-shopping-cart>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                        <v-expansion-panels class="d-flex flex-column list-campaigns" v-model="panels" multiple>
                            <v-radio-group class="py-0 mt-0" v-model="selectedCampaignId" v-if="displayCampaigns[selectedCampaignId].length>0">
                                <v-expansion-panel active-class="myprovet-expansion-panel" :style="getSelectedPanelColor(campaign[0])" v-for="campaign in displayCampaigns" :key="campaign[0].id">
                                    <v-expansion-panel-header class="campaign-form-expansion-header pb-0">
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" class="pl-1">
                                                    <v-radio :value="campaign[0].id" @click.stop @keyup.prevent>
                                                        <template v-slot:label>
                                                            <strong class="font-size-md dark-blue-color mt-1">{{ campaign[0].name }}</strong>

                                                            <v-spacer></v-spacer>

                                                            <strong class="font-size-md dark-blue-color">
                                                                {{ $t('campaigns.endsAt') }}: <span class="font-size-md description-text" style="font-weight: normal">{{ handleCampaignEndDate(campaign[0].end_date) }}</span>
                                                            </strong>
                                                        </template>
                                                    </v-radio>
                                                </v-col>
                                            </v-row>

                                            <v-row class="mt-0">
                                                <v-col cols="12" class="py-0" style="margin-top: -5px">
                                                    <div class="d-flex justify-end">
                                                        <span v-if="campaign[0].visible_id" class="font-size-xs secondary-text">ID {{ campaign[0].visible_id }}</span>
                                                    </div>
                                                </v-col>
                                            </v-row>

                                            <v-row class="mt-0" v-if="!isSimpleCampaings && campaign[0].split_promotion || isSimpleCampaings && !campaign[0].split_promotion || !isSimpleCampaings && !campaign[0].split_promotion">
                                                <v-col cols="10" class="pl-1">
                                                    <span class="font-size-sm description-text" v-html="getCampaignDesc(campaign[0])" ></span>
                                                </v-col>
                                            </v-row>
                                            <template v-slot:actions>
                                                <v-icon>$expand</v-icon>
                                            </template>
                                        </v-container>
                                    </v-expansion-panel-header>

                                    <v-expansion-panel-content>
                                        <template v-for="(campaignShoppingCart, index) in campaign">
                                            <div v-if="isSimpleCampaings && campaign[0].split_promotion" :key="'desc_'+index">
                                                <v-row class="mt-0" >
                                                    <v-col cols="10" class="pl-1">
                                                        <span class="font-size-sm description-text" style="margin-left: 30px;" v-html="getCampaignDesc(campaignShoppingCart)" ></span>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                            <v-card class="mt-4" v-if="campaignShoppingCart !== undefined" :key="index">
                                                <v-tooltip v-if="campaignShoppingCart.in_shopping_cart" bottom open-on-hover content-class="myprovet-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon v-on="on" v-bind="attrs" @click="tryRemoveCampaign({ campaign: campaign[index], force: true })" style="font-size: 32px; top: -10px; right: 25px; position: absolute; color: #b96161"> mdi-delete-circle </v-icon>
                                                    </template>

                                                    <span>{{ $t('campaigns.remove') }}</span>
                                                </v-tooltip>

                                                <v-tooltip v-if="campaignShoppingCart.in_shopping_cart" bottom open-on-hover content-class="myprovet-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon v-on="on" v-bind="attrs" @click.stop style="font-size: 32px; top: -10px; right: -10px; position: absolute; color: green"> mdi-checkbox-marked-circle </v-icon>
                                                    </template>

                                                    <span>{{ $t('campaigns.applied') }}</span>
                                                </v-tooltip>

                                                <campaign-shopping-cart v-if="product!=null"
                                                    :campaign="campaignShoppingCart"
                                                    :product="product"
                                                    @selected-product="setSelectedProduct($event)"
                                                    @selected-campaign="setSelectedCampaign($event)"
                                                    @selected-option="setSelectedOfferOption($event)"
                                                    @input-remove-campaign="tryRemoveCampaign($event)"
                                                    @open-product-details="openProductDetails($event)"
                                                    @open-matching-price-dialog="openMatchingPriceDialog($event)"
                                                >
                                                </campaign-shopping-cart>
                                            </v-card>

                                        </template>

                                        <v-container v-if="campaign[0].amount_of_requirements_needed > 0" class="mt-2">
                                            <v-row>
                                                <v-col cols="8" class="pl-1">
                                                    <strong class="font-size-md dark-blue-color">
                                                        {{ $t('campaigns.itemsNeeded') }}&nbsp;
                                                        <span class="font-size-md description-text" style="font-weight: normal">{{ campaign[0].amount_of_requirements_needed }}</span>
                                                    </strong>
                                                </v-col>

                                                <template v-if="campaign[0].minimum_value_necessary_quantity > 0">
                                                    <v-col cols="4" class="pr-0">
                                                        <v-btn v-if="campaign[0].minimum_value_necessary_quantity > 0" text outlined :class="handleNewMixCampaignButtonStyle(campaign[0])" @click="createNewOriginalCampaign(campaign[0])">{{ $t('campaigns.newMix') }}</v-btn>
                                                    </v-col>
                                                </template>
                                            </v-row>
                                        </v-container>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-radio-group>
                            <v-expansion-panel active-class="myprovet-expansion-panel" v-else>
                                <v-expansion-panel-header class="campaign-form-expansion-header" hide-actions>
                                    <v-container class="pb-0">
                                        <v-row>
                                            <v-col cols="12">
                                                <strong class="font-size-md dark-blue-color mt-1">{{ $t('campaigns.noResults') }}</strong>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-expansion-panel-header>

                                <!--<v-expansion-panel-content>
                                    <v-card class="mt-4">
                                        <product-shopping-cart  :product="product" :no-campaign="true" :account-blocked-message="accountBlockedMessage" :current-search-term="currentSearchTerm" @open-product-details="openProductDetails($event)"></product-shopping-cart>
                                    </v-card>
                                </v-expansion-panel-content>-->
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </v-container>
            </template>

            <template v-slot:buttons-left="{}">
                <v-row class="d-flex align-start pt-0 pb-0" v-if="isMobile">
                    <v-btn  text outlined :class="showHidePanelsButtonStyle +' btn-hide-details'" @click="handlePanels(false)" data-cy="app-dialog-close-btn">{{ showHidePanelsText }}</v-btn>
                </v-row>
                <v-btn v-else text outlined :class="showHidePanelsButtonStyle +' btn-hide-details'"  @click="handlePanels(false)" data-cy="app-dialog-close-btn">{{ showHidePanelsText }}</v-btn>
            </template>

            <template v-slot:buttons="{}">
                <v-row class="d-flex align-start pt-0 pb-0 add-mg-l" v-if="isMobile">
                    <v-btn text outlined :loading="isApplyButtonLoading" :disabled="isApplyButtonLoading" :class="handleApplyCampaignButtonStyle+' bt-add'" @click="getCampaignStatus" data-cy="app-dialog-submit-btn">{{ $t('campaigns.add') }}</v-btn>
                    <v-btn text outlined class="myprovet-btn-cancel" @click="$emit('input', $event)" data-cy="app-dialog-close-btn">{{ $t('common.close') }}</v-btn>
                </v-row>
                <v-btn v-if="!isMobile" text outlined class="myprovet-btn-cancel"  @click="$emit('input', $event)" data-cy="app-dialog-close-btn">{{ $t('common.close') }}</v-btn>
                <v-btn  v-if="!isMobile" text outlined :loading="isApplyButtonLoading" :disabled="isApplyButtonLoading" :class="handleApplyCampaignButtonStyle+' bt-add'" @click="getCampaignStatus" data-cy="app-dialog-submit-btn">{{ $t('campaigns.add') }}</v-btn>
            </template>
        </app-dialog>

        <app-dialog :value="isMatchingPriceDialogOpen" :title="$t('campaigns.matchingOffers')" :subtitle="$t('campaigns.chooseOne')" width="55vw" isPersistent>
            <template v-slot:content>
                <v-data-table
                    class="elevation-1 nowrap-headers"
                    show-select
                    multi-sort
                    hide-default-footer
                    single-select
                    :no-data-text="$t('campaigns.noRequirements')"
                    :no-results-text="$t('table.noResults')"
                    :loading-text="$t('table.loading')"
                    v-model="selectedRequirementWithMatchingPrice"
                    :items="requirementsWithMatchingPrice"
                    :headers="[
                        {
                            text: $t('campaigns.product'),
                            align: 'start',
                            sortable: false,
                            value: 'requirement',
                            width: '95%',
                        },
                    ]"
                >
                    <template #[`item.requirement`]="scope">
                        <div class="d-flex justify-start align-center">
                            <product-image
                                :is-new="!!scope.item.product.new"
                                :productCode="scope.item.product.invoice_code"
                                :imageSrc="scope.item.product.image"
                                width="35"
                                height="35"
                                max-width="35"
                                max-height="35"
                                style="cursor: pointer; position: relative"
                                @click="openProductDetails(scope.item.product)"
                            >
                            </product-image>

                            <div class="pl-2 datatable-designation-text" style="cursor: pointer" @click="openProductDetails(scope.item.product)">
                                {{ scope.item.product.designation }}
                            </div>
                        </div>
                    </template>
                </v-data-table>
            </template>

            <template v-slot:buttons="{}">
                <v-btn text outlined class="myprovet-btn-ok" @click="applyMatchingPriceSelection">{{ $t('campaigns.apply') }}</v-btn>
            </template>
        </app-dialog>

        <app-dialog v-if="isProductDetailsDialogOpen" :value="isProductDetailsDialogOpen" @input="isProductDetailsDialogOpen = $event" :title="$t('orders.base.productSheet')" width="55vw" :isProductDetails="true" :isResponsive="true" :showActions="false">
            <template v-slot:content>
                <product-details :product="selectedProduct" :key="selectedProduct.id" @change-product="selectedProduct = $event" @show-campaigns="onClickProductCampaign"></product-details>
            </template>
        </app-dialog>

        <confirmation-dialog :value="isRemoveCampaignDialogOpen" @onSuccess="remove()" @onCancel="isRemoveCampaignDialogOpen = false" :title="$t('layout.attention')" :question="$t('campaigns.removeQuestion')"> </confirmation-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import moment from 'moment';

export default {
    props: {
        isOpen: Boolean,
        campaigns: Array,
        product: Object,
        accountBlockedMessage: String,
        currentSearchTerm: String,
        //isMobile:Boolean,

        parentPage: {
            type: String,
            default: 'normal',
        },
    },

    data: () => ({
        panels: [],

        originatingProductId: 999999,
        originalCampaigns: [],
        selectedCampaignId: null,
        oldSelectedCampaignId: null,
        selectedCampaignUniqueId: null,
        campaign: null,

        initialProductsQuantities: [],

        areCampaignsLoading: false,
        areCampaignRealStatusLoading: false,

        isProductDetailsDialogOpen: false,
        selectedProduct: {},

        selectedOption: null,

        isMatchingPriceDialogOpen: false,
        requirementsWithMatchingPrice: [],
        selectedRequirementWithMatchingPrice: [],

        isRemoveCampaignDialogOpen: false,

        isCampaignStatusLoaded: false,
        campaignRealStatus: null,

        newMixMainCampaignId: null,
        newMixMainCampaignIndex: null,
        isSimpleCampaings:false,
        searchArticle:null,
        showSelected:false,
        isDisabledSelected:false,
        showSearchOptions:false,
    }),

    mounted() {
        //console.log('mounted productCampaignFrom',this.product);
        this.setSelectedProduct(this.product);
        this.handlePanels(true);
        var element = document.getElementById("app");
        element.classList.add("fix-background");
        this.isSimpleCampaings = window.location.href.indexOf('campaigns/simple-campaigns') !=-1 ? true : false
    },
    destroyed(){
        var element = document.getElementById("app");
        element.classList.remove("fix-background");
    },
    watch: {
        isCampaignStatusLoaded: {
            handler: function (value) {
                if (value) {
                    if (!this.campaignRealStatus) {
                        this.showError(this.$t('campaigns.noLongerAvailable'));
                        return;
                    }

                    this.applyCampaign();

                    this.isCampaignStatusLoaded = false;
                    this.campaignRealStatus = null;
                }
            },
            immediate: true,
        },
        selectedCampaignId: {
            handler: function (campaign_id) {
                const campaign = this.campaigns.find((campaign) => campaign.id === campaign_id);
                this.setSelectedCampaign(campaign);

                // If there are quantity for the product and none campaign is applied, then the quantity should be applied to the same product of the selected campaign
                if (campaign_id && !this.normalOrderStore.hasActiveCampaign(this.product.id) && this.normalOrderStore.getCartProductQuantity(this.product) > 0) {
                    const deferExit = (campaign) => {
                        this.normalOrderStore.handleMinimumValueCampaigns(campaign, campaign.requirements, campaign.offers);

                        // Handle multiplying offers quantity.
                        // We are simulating a manual increment.
                        this.normalOrderStore.handleCampaignOffersQuantity(campaign, campaign.requirements, campaign.offers, null);
                    };

                    const clearOldSelectedCampaign = () => {
                        const oldCampaign = this.campaigns.find((campaign) => campaign.id === this.oldSelectedCampaignId);

                        oldCampaign.requirements.forEach((requirement) => {
                            requirement.product.quantity = 0;
                        });

                        deferExit(oldCampaign);
                    };

                    this.normalOrderStore.getProducts.forEach((product) => {
                        const requirement = this.campaign.requirements.find((requirement) => requirement.product.id === product.id);
                        if (typeof requirement === 'undefined') return;
                        if (!requirement.product) return;

                        if (!this.campaign.in_shopping_cart) requirement.product.quantity = product.quantity;
                        if (this.normalOrderStore.getCartProductQuantity(this.product) > 0) this.initialProductsQuantities.push(product);
                    });

                    deferExit(this.campaign);

                    if (this.oldSelectedCampaignId !== null && this.oldSelectedCampaignId !== campaign_id) clearOldSelectedCampaign();
                }

                this.oldSelectedCampaignId = campaign_id;
            },
        },

        campaigns: {
            handler: function (campaigns) {
                this.originalCampaigns = JSON.parse(JSON.stringify(campaigns));
                if (this.newMixMainCampaignId !== null && this.newMixMainCampaignIndex !== null) {
                    let campaign_id = this.newMixMainCampaignId;
                    let campaign_index = this.newMixMainCampaignIndex;

                    this.newMixMainCampaignId = null;
                    this.newMixMainCampaignIndex = null;

                    campaign_index += 1; // We want select the next index

                    const campaign = campaigns.find((c) => c.id == campaign_id && c.index == campaign_index);

                    if (campaign) {
                        this.setSelectedCampaign(campaign);
                        this.handlePanels(true);
                    }
                } else {
                    // @Note: Select always the first campaign
                    if (typeof campaigns[0] !== 'undefined' && this.selectedCampaignId === null) {
                        this.setSelectedCampaign(campaigns[0]);
                    }

                    this.handlePanels(true);
                }
            },
            immediate: true,
            deep: true,
        },
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useNormalOrderStore,useAppStore),

        getDialogWidth() {
            return this.getResponsiveDialogWidth('95vw', '65vw');
        },

        showHidePanelsText() {
            return this.panels.length > 0 ? this.$t('campaigns.hideDetails') : this.$t('campaigns.showDetails');
        },

        showHidePanelsButtonStyle() {
            return this.campaigns.length > 0 && !this.areCampaignsLoading ? 'myprovet-btn-cancel' : 'myprovet-btn-disabled';
        },

        handleApplyCampaignButtonStyle() {
            if (!this.campaign) return 'myprovet-btn-disabled';
            if (this.campaign.in_shopping_cart) return 'myprovet-btn-disabled';

            const requirement = this.campaign.requirements.find((it) => it.exceeding_quantity == 1);
            if (requirement) {
                const minimumValueMinQuantity = this.campaign.requirements.reduce((acc, r) => acc + r.product.quantity, 0);
                return minimumValueMinQuantity <= requirement.min_quantity ? 'myprovet-btn-disabled' : 'myprovet-btn-ok';
            }
            const hasQuantity = this.campaign.requirements.some((requirement) => requirement?.product.quantity > 0);
            return hasQuantity ? 'myprovet-btn-ok' : 'myprovet-btn-disabled';
        },

        isApplyButtonLoading() {
            if (this.areCampaignsLoading) return true;
            if (this.areCampaignRealStatusLoading) return true;

            return false;
        },

        isActiveCampaign() {
            return this.normalOrderStore.isActiveCampaignByUniqueIdAndProduct(this.product.id, this.campaign.unique_id);
        },

        hasActiveCampaign() {
            return Object.values(this.displayCampaigns).some((campaignArray) => campaignArray.some((c) => c.in_shopping_cart));
        },

        hasMultipleOptions() {
            if (this.campaign.offers.length === 0) {
                return false;
            }

            // If the first offer's option is different than any other, we can choose from multiple offers.
            const firstOffer = this.campaign.offers[0];
            return this.campaign.offers.some((it) => it.option !== firstOffer.option);
        },

        displayCampaigns() {
            let arrayIndex = 0;

            let results = this.campaigns.reduce((acc, campaign) => {
                if (!acc[campaign.id]) {
                    acc[campaign.id] = [];
                    arrayIndex = 0;
                }

                acc[campaign.id][arrayIndex] = campaign;
                arrayIndex++;

                return acc;
            }, {});
            if(this.campaign.split_promotion && this.isSimpleCampaings){
                this.showSearchOptions=true
                let self=this
                if(this.showSelected){
                    results[this.campaign.id]=_.filter(results[this.campaign.id],{in_shopping_cart:true})
                }
                if(_.size(this.searchArticle)>0){
                    let campIDs = []

                        _.each(results[this.campaign.id],(camp)=>{
                            let rs = camp.requirements.filter(item => {
                                function valStr(string) {
                                    string = string + ''
                                    string = string.replace(/ /g, '')
                                    let strq = self.searchArticle
                                    strq = strq.replace(/ /g, '')
                                    let terms = _.split(strq,'%')
                                    if(_.size(terms)>1){
                                        return terms.every(term => string.toLowerCase().includes(term))
                                    }else{
                                        return string.toLowerCase().indexOf(strq.toLowerCase()) > -1
                                    }
                                }
                                //Object.values(item.name).find(valStr)
                                var result =  valStr(item.product.designation) || valStr(item.product.code) || valStr(item.product.ean);
                                return result != undefined && result != false
                            })
                            if(rs.length>0){
                                campIDs.push(camp.unique_id)
                            }
                        })
                        results[this.campaign.id] = _.filter(results[this.campaign.id],(rq)=>{
                             return _.indexOf(campIDs,rq.unique_id)!=-1
                        })
                       setTimeout(()=>{
                         this.handlePanels(true);
                       },0)

                }else{
                    this.handlePanels(true);
                }

            }
           return results
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
    },

    methods: {
        changeShowSelectedCampaigns(){
            setTimeout(()=>{
                this.handlePanels(true);
            },0)
        },
        onClickProductCampaign(product) {
            this.setSelectedProduct(product);
            this.$emit('show-campaigns', product);
        },

        handlePanels(forceExpandAll = false) {
            if (forceExpandAll) {
                this.panels = [...this.campaigns.keys()].map((k, i) => i);
            } else {
                this.panels = this.panels.length > 0 ? [] : [...this.campaigns.keys()].map((k, i) => i);
            }
        },

        handleNewMixCampaignButtonStyle(campaign) {
            if (!campaign) return 'myprovet-btn-disabled';

            // Get campaign with the maximum index for the given campaign_id
            const targetCampaign = this.campaigns.filter((c) => c.id === campaign.id).reduce((prev, current) => (prev && prev.index > current.index ? prev : current));

            return targetCampaign && targetCampaign.in_shopping_cart //
                ? 'myprovet-btn-ok'
                : 'myprovet-btn-disabled';
        },

        getSelectedPanelColor(campaign) {
            if (campaign.in_shopping_cart) return 'background-color: #e9ffec !important;';
            return campaign.id === this.selectedCampaignId ? 'background-color: #e9f7fd !important;' : '';
        },

        handleCampaignEndDate(end_date) {
            return end_date ? moment(end_date).format('YYYY-MM-DD') : '-----';
        },

        tryRemoveCampaign(params) {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            const campaign = params.campaign;
            const product = params.product;
            const isIncrement = params.isIncrement ?? null;
            const forceRemove = params.force ?? false;

            this.setSelectedCampaign(campaign);

            if (forceRemove) {
                this.isRemoveCampaignDialogOpen = true;
                return;
            }

            const minimumValueMinQuantity = campaign.requirements.reduce((acc, r) => {
                if (r.product.id !== product.id) {
                    return acc + r.product.quantity;
                }

                return acc;
            }, 0);

            const fulfilledRequirements = [];

            for (const requirement of campaign.requirements) {
                if (!requirement.product.quantity) continue; // didn't buy in to this requirement.
                fulfilledRequirements.push(requirement);
            }

            if (campaign.amount_of_requirements_needed > 0 && fulfilledRequirements.length > campaign.amount_of_requirements_needed && minimumValueMinQuantity >= campaign.minimum_value_necessary_quantity) {
                if (isIncrement === null) product.quantity = 0;
                this.normalOrderStore.changeCampaignQuantityOnExisting(product.campaign_unique_id, product.index, isIncrement, this.currentSearchTerm);
            } else {
                if (this.isActiveCampaign) this.isRemoveCampaignDialogOpen = true;
                //this.isRemoveCampaignDialogOpen = true;
            }
        },

        remove() {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            this.normalOrderStore.removeCampaign(this.campaign.unique_id, this.selectedProduct.id);
            this.isRemoveCampaignDialogOpen = false;

            this.$emit('check-applied-campaigns');
        },

        setSelectedProduct(product) {
            this.selectedProduct = product;
        },

        setSelectedCampaign(campaign) {
            this.campaign = campaign;
            this.selectedCampaignId = campaign.id;
        },

        setSelectedOfferOption(option) {
            this.selectedOption = option;
            this.normalOrderStore.updateOfferSelectedOption(this.campaign.id, this.selectedProduct.originating_product_id, option);
        },

        getCampaignDesc(campaign){

            if(_.size(campaign)>0){
                if(campaign.split_promotion){
                //if(campaign.split_promotion && !this.isSimpleCampaings){
                    //let requirement = _.find(campaign.requirements,{referenceable:''+this.selectedProduct.code})
                    const target = String(this.selectedProduct.code);
                    const requirement = _.find(campaign.requirements, r => String(r.referenceable) === target);
                    if(requirement){
                        if(campaign.offer_quantity >0  && requirement && requirement.obs == null ){
                            let baseQty = requirement.min_quantity
                            let offerQty = campaign.offer_quantity
                            return  'NA COMPRA DE '+baseQty+' UNI, '+offerQty+' DE OFERTA'
                        }else{
                            if(_.has(requirement,'obs')){
                                if(requirement.obs)
                                    return _.toUpper(requirement.obs)
                            }
                        }
                    }else{
                        if(_.size(campaign.requirements)>0)
                            return campaign.requirements[0].obs!=null?_.toUpper(campaign.requirements[0].obs):_.toUpper(campaign.description)
                    }
                }
                return campaign.description!=null?_.toUpper(campaign.description):''
            }
            return ''
        },

        getCampaignStatus() {
            this.areCampaignRealStatusLoading = true;
            this.isCampaignStatusLoaded = false;
            this.campaignRealStatus = null;

            axios.get(`/api/campaigns/${this.campaign.id}/status`).then(({ data }) => {
                this.campaignRealStatus = data;
                this.isCampaignStatusLoaded = true;
                this.areCampaignRealStatusLoading = false;
            });
        },

        applyCampaign() {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            if (this.branchStore.isBlocked) {
                this.showError(this.accountBlockedMessage);
                return;
            }

            if (this.isActiveCampaign) {
                this.showError(this.$t('campaigns.isActive'));
                return;
            }

            if (this.hasMultipleOptions && this.selectedOption === null) {
                this.showError(this.$t('campaigns.chooseOffer'));
                return;
            }

            const fulfilledRequirements = [];

            for (const requirement of this.campaign.requirements) {
                if (!requirement.product.quantity) continue; // didn't buy in to this requirement.

                const isMinimumOK = requirement.product.quantity > 0 && requirement.product.quantity >= requirement.min_quantity;
                const isMaximumOK = requirement.max_quantity === 0 || requirement.product.quantity <= requirement.max_quantity;
                const isExceedingQuantityNOK = requirement.product.quantity > 0 && requirement.product.quantity <= requirement.min_quantity;

                if (!isMinimumOK) {
                    this.showError(this.$t('campaigns.minQuantity', { n: requirement.min_quantity }));
                    return;
                }

                if (!isMaximumOK && !requirement.product.exceeding_quantity) {
                    this.showError(this.$t('campaigns.maxQuantity', { n: requirement.max_quantity }));
                    return;
                }

                if (isExceedingQuantityNOK && requirement.exceeding_quantity) {
                    this.showError(this.$t('campaigns.moreThan', { n: requirement.min_quantity }));
                    return;
                }

                fulfilledRequirements.push(requirement);
            }

            if (fulfilledRequirements.length === 0) {
                this.showError(this.$t('campaigns.validQuantities'));
                return;
            }

            const amountRequirementsNeeded = this.campaign.amount_of_requirements_needed;

            const hasMinimumRequirements = amountRequirementsNeeded > 0;
            const meetsMinimumRequirements = fulfilledRequirements.length >= amountRequirementsNeeded;

            if (hasMinimumRequirements && !meetsMinimumRequirements) {
                this.showError(this.$t('campaigns.productsNeeded', { done: fulfilledRequirements.length, needed: amountRequirementsNeeded }));
                return;
            }

            // Check if the requirements necessary quantity is guaranteed
            const minimumValueMinQuantity = this.campaign.requirements.reduce((acc, r) => acc + r.product.quantity, 0);
            if (minimumValueMinQuantity < this.campaign.minimum_value_necessary_quantity) {
                this.showError(this.$t('campaigns.minUnitsNeeded', { done: minimumValueMinQuantity, needed: this.campaign.minimum_value_necessary_quantity }));
                return;
            }
            //console.log('applyCampaign',this.normalOrderStore.getCampaigns,this.campaigns)
            if(this.campaign.split_promotion && this.isSimpleCampaings){
               let listCampsToAdd = []
               _.each(this.campaigns,(camp)=>{
                   if(this.campaign.id==camp.id && !camp.in_shopping_cart){
                       let addCamp=false
                      _.each(camp.requirements,(req)=>{
                          if(req.product.quantity>0){
                            addCamp=true
                          }
                      })
                      if(addCamp){
                        listCampsToAdd.push(camp)
                      }
                   }
               })
               if(listCampsToAdd.length>0){
                 _.each(listCampsToAdd,(camp)=>{
                    this.normalOrderStore.addCampaign(camp, camp.requirements, camp.offers, this.currentSearchTerm);
                 })
                 this.showSuccess(this.$t('campaigns.addedMany'));
                }
            }else{
                // We can't send `fulfilledRequirements` as we need to show the full ('base') campaign the next time that the user sees this screen.
                this.normalOrderStore.addCampaign(this.campaign, this.campaign.requirements, this.campaign.offers, this.currentSearchTerm);
                this.showSuccess(this.$t('campaigns.addedOne'));
            }

            this.$emit('check-applied-campaigns')

            // Remove the initial quantity of each stored product that was used in the campaign requirements
            if (this.initialProductsQuantities.length > 0) {
                this.handleProductsQuantitiesWithoutCampaign();
            }
        },

        handleProductsQuantitiesWithoutCampaign() {
            this.campaign.requirements.forEach((requirement) => {
                const product = this.initialProductsQuantities.find((p) => p.id == requirement.product.id);

                if (product) {
                    let amount = product.quantity - requirement.product.quantity;

                    if (amount <= 0) {
                        this.normalOrderStore.removeProduct(product.id);
                        return;
                    }

                    this.normalOrderStore.setProductQuantity(product.id, amount);
                }
            });
        },

        createNewOriginalCampaign(campaign) {
            this.newMixMainCampaignId = campaign.id;
            this.newMixMainCampaignIndex = campaign.index;

            this.setSelectedCampaign(campaign);
            this.$emit('create-new-original-campaign', campaign);
        },

        openProductDetails(product) {
            this.setSelectedProduct(product);
            this.isProductDetailsDialogOpen = true;
        },

        openMatchingPriceDialog(requirementsWithMatchingPrice) {

            this.requirementsWithMatchingPrice = requirementsWithMatchingPrice;
            let total=0
            _.each(this.campaign.requirements,(elem)=>{
                    if(!elem.product.isOffer)
                      total= total +elem.product.quantity
            })
            //console.log('openMatchingPriceDialog',(this.campaign.minimum_value_necessary_quantity <= total));
            if(this.campaign.minimum_value_necessary_quantity <= total){
                this.isMatchingPriceDialogOpen = this.requirementsWithMatchingPrice.length > 0;
            }
            /*else{
                this.selectedRequirementWithMatchingPrice={}
                for (const requirement of this.campaign.requirements) {
                    requirement.isCheaperSelected = false;
                }
                this.normalOrderStore.handleCampaignOffersQuantity(this.campaign, this.campaign.requirements, this.campaign.offers, this.selectedRequirementWithMatchingPrice);
            }*/

        },

        applyMatchingPriceSelection() {
            if (this.selectedRequirementWithMatchingPrice.length !== 1) {
                this.showError(this.$t('campaigns.chooseOfferContinue'));
                return;
            }

            const selectedRequirementWithMatchingPrice = this.selectedRequirementWithMatchingPrice.at(0); // single-selection

            for (const requirement of this.campaign.requirements) {
                requirement.isCheaperSelected = requirement.product.uniqueId === selectedRequirementWithMatchingPrice.product.uniqueId;
            }

            this.isMatchingPriceDialogOpen = false;
            this.normalOrderStore.handleMinimumValueCampaigns(this.campaign, this.campaign.requirements, this.campaign.offers);
            // Handle multiplying offers quantity.
            // We are simulating a manual increment.
            this.normalOrderStore.handleCampaignOffersQuantity(this.campaign, this.campaign.requirements, this.campaign.offers, selectedRequirementWithMatchingPrice);
        },
    },
};
</script>

<style>
.campaign-form-expansion-header.v-expansion-panel-header {
    pointer-events: none;
}
.campaign-form-expansion-header .v-expansion-panel-header__icon,
.campaign-form-expansion-header .v-input--selection-controls__input {
    pointer-events: all;
}

.main-container {
    min-height: 32vh;
    height: auto;
    max-height: 70vh;
    overflow-y: auto;
}
</style>
